import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ColumnFilterService {
  constructor(private httpClient: HttpClient) {}

  public fetchFilterOptions(endpoint: string, filterName: string): Observable<(string | boolean | number)[]> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('filterName', filterName);
    return this.httpClient.get<(string | boolean | number)[]>(`${environment.apiUrl}${endpoint}`, { params: queryParams });
  }
}
